{% block sw_order_detail_revocation %}
<sw-card
    v-if="revocations.length > 0"
    :title="$tc('jga-revocation.detailCard.cardTitle')"
    :is-loading="isLoading"
>
    <sw-data-grid
        :data-source="revocations"
        :columns="revocationColumns"
        :show-settings="false"
        :show-selection="false"
        :show-actions="false"
        :compact-mode="true"
    >
        <template #column-submittedAt="{ item }">
            {{ item.submittedAt | date({ hour: '2-digit', minute: '2-digit' }) }}
        </template>

        <template #column-reason="{ item }">
            {{ item.reason || '—' }}
        </template>
    </sw-data-grid>
</sw-card>
{% endblock %}
